import {DASHBOARD} from '@constants/internal-route.constant'
import {useBranding} from '@context/Branding'
import clsx from 'clsx'
import {useEffect} from 'react'
import {Link} from 'react-router-dom'
import {ILayout, useLayout} from '../../core'
import {DefaultTitle} from './page-title/DefaultTitle'
import {PageActions} from './page-title/PageActions'
import {useIsDesktop} from './page-title/useIsDesktop'
import {Topbar} from './Topbar'

// ams has no REACT_APP_BRAND_LOGO; without a company logo the bundled one shows (as in stock).
const DEFAULT_LOGO = '/media/logos/logo.png'

// Body attributes the header owns; removed on unmount (see Sidebar for why).
const HEADER_BODY_ATTRIBUTES = ['data-kt-app-header-fixed', 'data-kt-app-header-fixed-mobile']

const updateDOM = (config: ILayout) => {
  const fixed = config.app?.header?.default?.fixed
  if (fixed?.desktop) document.body.setAttribute('data-kt-app-header-fixed', 'true')
  if (fixed?.mobile) document.body.setAttribute('data-kt-app-header-fixed-mobile', 'true')
}

export function HeaderWrapper() {
  const {config} = useLayout()
  const {logoUrl} = useBranding()
  const isDesktop = useIsDesktop()
  const header = config.app?.header
  const titleInHeader = isDesktop && header?.default?.content === 'page-title'

  useEffect(() => {
    updateDOM(config)
    return () => HEADER_BODY_ATTRIBUTES.forEach((attr) => document.body.removeAttribute(attr))
  }, [config])

  if (!header?.display) {
    return null
  }

  return (
    <div id='kt_app_header' className='app-header'>
      <div
        id='kt_app_header_container'
        className={clsx(
          'app-container',
          header.default?.container === 'fixed' ? 'container-xxl' : 'container-fluid',
          header.default?.containerClass
        )}
      >
        {/* begin::Sidebar mobile toggle + mobile logo */}
        {config.app?.sidebar?.display && (
          <div className='d-flex align-items-center d-lg-none ms-n2 me-2' title='Show sidebar menu'>
            <div
              className='btn btn-icon btn-active-color-primary w-35px h-35px'
              id='kt_app_sidebar_mobile_toggle'
            >
              <i className='bi bi-list fs-1'></i>
            </div>
            <Link to={DASHBOARD} className='d-flex align-items-center ms-1'>
              <img alt='Logo' src={logoUrl || DEFAULT_LOGO} className='h-30px mw-125px' />
            </Link>
          </div>
        )}
        {/* end::Sidebar mobile toggle + mobile logo */}

        <div
          id='kt_app_header_wrapper'
          className='d-flex align-items-stretch justify-content-between flex-grow-1 min-w-0'
        >
          {/* Desktop: page title on the left, the page's actions before the topbar. Below lg both
              render at the top of the content instead (see Content). */}
          {titleInHeader && (
            <div className='d-flex align-items-center min-w-0 me-3' id='kt_app_header_page_title'>
              <DefaultTitle />
            </div>
          )}
          <div className='flex-grow-1'></div>
          {titleInHeader && <PageActions className='me-4' />}
          <Topbar />
        </div>
      </div>
    </div>
  )
}
